/* eslint-disable @typescript-eslint/no-explicit-any */
import { ref, watch } from 'vue';
import { commonapi } from '@/apis/api2';

// deadpool 项目名称
export const PROJECT = {
    spot: 'bybit.spot.fe',
};

// deadpool keys
export const DEADPOOLKEYS = {
    launchpoolGray: 'launchpoolGray', // launchpool 降级
    depositEarnGray: 'depositEarnGray', // banner 接口开关
    launchpadGray: 'launchpadGray', // launchpad 降级
};

const getVal = (val) => !!Number(val);

// 当前开关key
export function useDeadpool(key) {
    const isDeadpoolReady = ref(false);
    const isGray = ref(false);

    // 转换接口返回值
    const getGary = async () => {
        const params = {
            project_name: PROJECT.spot,
            keys: [
                key,
            ],
        };
        try {
            const res = await commonapi.getDeadPool(params);
            const { success, result } = res;

            if (success) {
                (result?.data ?? []).forEach((item) => {
                    switch (item.name) {
                        case key:
                            isGray.value = getVal(item?.value);
                            break;

                        default:
                            break;
                    }
                });
            }

            isDeadpoolReady.value = true;
        } catch {
            isDeadpoolReady.value = true;
        }
    };
    watch(
        () => key,
        (newKey) => {
            if (newKey && !isDeadpoolReady.value) {
                getGary();
            }
        },
        { immediate: true },
    );

    return {
        isDeadpoolReady, // 接口是否完成
        isGray, // 当前key 的灰度
    };
}
